export default "__VITE_ASSET__a84fde1c__"